import { defineStore } from 'pinia';
import { useOrderStatuses } from '@/store/order-statuses';
import { OrderState } from '@/ApiClient';

export const useOrders = defineStore('orders', {
  actions: {
    // Helper fns
    isPlanned(order) {
      const status = useOrderStatuses().getById(order.statusId);

      return status.state === OrderState.Planned;
    },
    isPlaced(order) {
      return !this.isPlanned(order);
    },
    totalPlaced(ordersOrArticleOrderRows) {
      return this.totalOfStatus(ordersOrArticleOrderRows, true);
    },
    totalPlanned(ordersOrArticleOrderRows) {
      return this.totalOfStatus(ordersOrArticleOrderRows, false);
    },
    totalOfStatus(ordersOrArticleOrderRows, placed = true) {
      const stateCheck = (order, placed) => (placed ? this.isPlaced(order) : this.isPlanned(order));

      return ordersOrArticleOrderRows.reduce((total, ordersOrArticleOrderRow) => {
        return (
          total +
          (stateCheck(ordersOrArticleOrderRow.order || ordersOrArticleOrderRow, placed)
            ? ordersOrArticleOrderRow.quantity || 0
            : 0)
        );
      }, 0);
    },
  },
});
